import { RedirectSourceEnum } from '../redirect-source-enum';

export const environment = {
  production: true,
  environment: 'production',

  // the Application id for this specific app
  authAppId: '6-sidBBhYXRFmSe7Fev-A0BUUkFafA1aX2Em0iCrOho',

  // the successful login return url
  authRedirectURI: 'https://workspace.reconcept.nl/login/success/',

  // the RedirectSource corresponding with backend
  authRedirectSource: RedirectSourceEnum.WORKSPACE_DASHBOARD,

  // the requested grant scope
  authScope: 'user workspace',

  bugsnagApiKey: '98cb4899b91567c800fc74167974dffa',

  applicationName: 'Kwaliteitsdashboard',
};
